export default "__VITE_ASSET__D44IcARk__"